// Modules
import cn from 'classnames';

// Types
import type { TProgressBarProps } from './ProgressBar.type';

// Styles
import styles from './styles.module.scss';

// Helpers
import { snakeCase } from '../../helpers/typography';

// Constants
import { PROGRESS_BAR_DEFAULT_PROPS } from './ProgressBar.constant';

export const ProgressBar = (props: TProgressBarProps) => {
	const {
		className,
		indicatorClassName,
		labelClassName,
		labelPosition = PROGRESS_BAR_DEFAULT_PROPS.labelPosition,
		trackClassName,
		value = PROGRESS_BAR_DEFAULT_PROPS.value,
		...restProps
	} = props;
	const validValue = Math.min(Math.max(value, 0), 100);

	const progressBarCN = cn(styles.legion_progress_bar, className, styles[`label_${snakeCase(labelPosition)}`]);
	const trackCN = cn(styles.track, trackClassName);
	const indicatorCN = cn(styles.indicator, indicatorClassName);
	const labelCN = cn(styles.label, labelClassName);
	const floatLabelCN = cn(styles.float_label, labelClassName);

	return (
		<div className={progressBarCN} {...restProps}>
      <span className={trackCN}>
        <span className={indicatorCN} style={{ width: `${validValue}%` }}>
					{labelPosition?.includes('float') && (
						<div className={floatLabelCN}>
							<p>{`${validValue}%`}</p>
						</div>
					)}
				</span>
      </span>
			{!labelPosition?.includes('float') && (
				<p className={labelCN}>{`${validValue}%`}</p>
			)}
		</div>
	);
}

export default ProgressBar;
